import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";
import Utils from "../../utilities/Utils";
import { submitForm } from "../../utilities/HtmlUtils";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class TextComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

     let field = this.props.field;
    FormValidationUtils.runInitJavascript(field);
   
  }


  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }

  onTextEditChange = (e) => {
    console.log('input change:', e.target.value);
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;

    field.Value = val;
    FormValidationUtils.validateText(field);
    FormValidationUtils.runKeyStrokeJavascript(field);
    this.props.callbackElement(field.parent.parent.parent);
  }

  onBlur = (e) => {
    let field = this.props.field;
    FormValidationUtils.evalRegularExpression(field)

    if (field.Valid) {
       FormValidationUtils.runJavascript(field);
      
    }

    this.props.callbackElement(field.parent.parent.parent);
  }

  handleKeyDown = (e) => {
    console.log('key: ', e.key, e.keyCode);
    let field = this.props.field;
    if (e.key === 'Enter' && field.triggerSubmitOnEnter) {
      e.preventDefault();
      // FormValidationUtils.evalRegularExpression(field);
      if (this.props.field.Valid) {
        FormValidationUtils.runKeyStrokeJavascript(field);
        if (field.Valid) {
          submitForm(field);
        }
      }
    }
  }

  render() {
    let field = this.props.field;
    let displayfield: boolean = true;

    field.Visible = field.Visible ?? true; 

    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    let foundFilterFields: FormSectionElements[];
    let foundFilterField: FormSectionElements;

    let isCounterDisplay = this.props.field.counterVisible;

    let lengthAndRow = this.props.field.Length;
    let numOfRow = 5;
    let maxLength = 500;

    if (lengthAndRow && lengthAndRow.indexOf(",") > 0) {
      let arr = lengthAndRow.split(",");
      numOfRow = parseInt(arr[0].toString(), 10);
      maxLength = parseInt(arr[1].toString(), 10);
    } else if (lengthAndRow) {
      maxLength = parseInt(lengthAndRow);
    }

    if (this.props.field.FilterField != null) {
      let filterValue;
      let baseName;
      let bindName;
      let parts = this.props.field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }

      foundFilterField = XMLParser.findSectionElement(this.props.field, bindName);

      if (foundFilterField != null) {
        filterValue = foundFilterField.Value;

        if ((foundFilterField != null && (filterValue == null || filterValue == '')) || filterValue != null && (this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1)) {
          displayfield = false;
        }
      } else {
        displayfield = true;
      }


      if (this.props.field.FilterCompareMethod != null && this.props.field.FilterCompareMethod != '' && foundFilterField != null && foundFilterField.Datatype == 'Date') {
        if (foundFilterField.Value) {
          let otherDate = new Date(foundFilterField.Value);
          let today = new Date();
          var diff = otherDate.getTime() - today.getTime();
          var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
          if (this.props.field.FilterCompareMethod == 'greater')
            displayfield = diffDays <= Number.parseInt(this.props.field.FilterValue);
          else
            displayfield = diffDays >= Number.parseInt(this.props.field.FilterValue);
        } else {
          displayfield = false;
        }
      }

    }

    const numArray = field.Length?.match(/\d+/g).map(Number);
    if (numArray && numArray.length > 0) {
      maxLength = numArray[0];
    }
    this.props.field.Visible = displayfield;
    if (displayfield) {
      if (editable) {
        if (field.Value == null)
          field.Value = "";
        const validClass = field.Length ? 'ontario-input' + " " + field.Length : 'ontario-input';
        const invalidClass = field.Length ? 'ontario-input' + " " + field.Length + ' ontario-input__error' : 'ontario-input ontario-input__error';

        controlArray.push(
          <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id}>
            <div key={'fdLbl_div_' + this.props.field.Id} >
              {labelControlArray}
            </div>

            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />

            {(!field.TextType || field.TextType === 'Input') && (
              <input style={{ display: field.Visible ? 'block' : 'none', color: field.ReadOnly? 'color.palette.greyscale40':'color.palette.black' }}
                type="text"
                id={field.LoadBindName}
                key={'fdIpt_' + field.LoadBindName}
                onBlur={this.onBlur}
                className={field.Valid || (!field.Valid && !field.Touched) ? validClass : invalidClass}
                required={requiredField}
                maxLength={maxLength}
                value={field.Value}
                readOnly={field.ReadOnly}
                aria-required={field.Optional !== 'Y'}
                aria-describedby={`${field.LoadBindName}-${field.Id}`}
                aria-invalid={!field.Valid && field.Touched}
                onChange={this.onTextEditChange}
                onKeyDown={this.handleKeyDown}
              />
            )}

            {field.TextType === 'Value' && (
              <p>{field.Value}</p>
            )}
            <div style={{ display: isCounterDisplay ? 'block' : 'none' }} className="word-count">
              {isCounterDisplay ? this.valueLength(this.props.field.Value) + "/" + maxLength : <br />}
            </div>
          </div>
        );
      } else {
        controlArray.push(
          <div className='pdf-two-column'>
            <div>{title}</div>
            <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{this.props.field.Value}</div>
          </div>
        );
      }
    }

    return controlArray;
  }
}